import TypeIcon from "../TypeIcon";

export interface PlaceParams extends be.LocationPrediction {
  final?: string;
  locations?: be.Location[];
}

function SearchMeta({ title }: { title: string }) {
  return (
    <div className="flex items-center justify-center -mt-1 -mb-1">
      <div>
        <p className="m-0 text-base font-thin text-gray-500">{title}</p>
      </div>
    </div>
  );
}

export function Place({
  final,
  title,
  description,
  source,
  type,
  typestring,
}: PlaceParams): JSX.Element {
  if (source == "searchMeta") {
    return <SearchMeta title={title} />;
  } else if (source == "fixedHeader") {
    return (
      <div className="-mb-4">
        <span className="text-base font-bold">{title}</span>
      </div>
    );
  } else if (source == "fixedHudson") {
    return (
      <div className={`relative flex items-center py-2`}>
        <div className="mr-4 bg-white rounded-xl ">
          <TypeIcon typeKey={type} type={typestring} className="flex-none w-6 h-6" />
        </div>

        <div className="flex flex-wrap items-end">
          <p className="flex flex-wrap items-end m-0 text-base">
            <span className="pr-2 font-medium">{title}</span>
            <span className="text-sm font-thin  whitespace-nowrap">{description}</span>
          </p>
        </div>
      </div>
    );
  } else if (source == "fixed") {
    return (
      <div className="py-1">
        <div className="flex">
          <div className="flex items-center text-base">
            <TypeIcon typeKey={type} type={typestring} className="flex-none w-4 h-4 mr-4" />
            <span className="grow hover:underline ">{title}</span>
          </div>
        </div>
      </div>
    );
  } else {
    return (
      <div className="relative flex items-center">
        <TypeIcon typeKey={type} type={typestring} className="w-8 h-8 mr-4 flex-shrink-0" />
        <div>
          <p className="m-0 text-base font-semibold">{title}</p>
          <p className="m-0 text-sm text-gray-500 ">{description}</p>
        </div>
      </div>
    );
  }
}
